module.exports = __webpack_public_path__ + "static/media/neoInsuranceLogoWhite_risk.dc84aa5c.svg";